import { Box } from '@mui/material';
import googleMark from '../../assets/google-logo.svg';
import { CONTROL_ICON_SIZE } from './icons';

/** Google's brand mark is separate from the application's Lucide icon set. */
export function GoogleLogo() {
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        display: 'inline-block',
        width: CONTROL_ICON_SIZE,
        height: CONTROL_ICON_SIZE,
        flexShrink: 0,
        verticalAlign: 'middle',
        bgcolor: 'currentColor',
        mask: `url(${googleMark}) center / contain no-repeat`,
        WebkitMask: `url(${googleMark}) center / contain no-repeat`,
      }}
    />
  );
}
